<div style="width: 100%;">

  <div style="text-align:right; float:right; width:35%">
    <h2 style="cursor:pointer; display:block;" class="flex-aligned-div" (click)="openDeploymentInformationPopup()">
      Deployment information
      <mat-icon data-html="true" style="color:white">info</mat-icon>
    </h2>
  </div>
  <div style="clear: both;"></div>

  <div class="flex-center">
    <div class="contentWidth">
      <div style="height: calc(90vh - 100px); overflow-y: auto;">
        <form [formGroup]="CSRForm" autocomplete="off">
          <ng-container formArrayName="CSRRows">
            <table #objTable
              mat-table
              multiTemplateDataRows
              matSort
              [dataSource]="dataSource.data"
              class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">

              <ng-container matColumnDef="headertitle">
                <th class="title-col" mat-header-cell *matHeaderCellDef [attr.colspan]="columnsToDisplay.length - 1">
                  <div class="pull-left">
                    <h4>Global Task List</h4>
                  </div>
                </th>
              </ng-container>
              <ng-container matColumnDef="headeraddbutton">
                <th class="butt-col" mat-header-cell *matHeaderCellDef>
                  <div class="OrangeButton">
                    <button mat-raised-button
                      (click)="addNewRow()"
                      [matTooltip]="getAddPatternTooltip()"
                      [disabled]="!isEnglishLanguage()"
                      class="button-color-fix pull-right">
                      <mat-icon class="icon-color-fix icon-padding-fix">add_box</mat-icon>
                    </button>
                  </div>
                </th>
              </ng-container>

              <ng-container matColumnDef="arrow">
                <th mat-header-cell *matHeaderCellDef style="width:5%"></th>
                <td mat-cell style="width:5%" *matCellDef="let element, let i = dataIndex"
                  (click)="pushPopElement(i)">
                  @if ( !CSRForm.get('CSRRows')?.value[i]?.isNewRow ) {
                    @if (checkExpanded(i)) {
                      <span class="material-icons"
                        >
                        expand_less
                      </span>
                    } @else {
                      <span class="material-icons">
                        expand_more
                      </span>
                    }
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="patternid">
                <th mat-header-cell *matHeaderCellDef style="width:5%">Pattern ID</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:5%">
                  <div>
                    @if (CSRForm.get('CSRRows')?.value[i].patternDefinitionId > 0) {
                      GTL_{{ CSRForm.get('CSRRows')?.value[i].patternDefinitionId }}
                    } @else {
                      <span style="font-style: italic; color: #888;">New</span>
                    }
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef style="width:12%">Description</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:12%">
                                    <textareaoverlay [inputControls]="{
                                                     isOpenOverlay: CSRForm?.get('CSRRows')?.value[i].isOpenOverlay,
                                                     textAreaId: CSRForm?.get('CSRRows')?.value[i].textAreaId,
                                                     isEditable: !CSRForm?.get('CSRRows')?.value[i].isEditable,
                                                     maxCommentLength: CSRForm?.get('CSRRows')?.value[i].maxCommentLength,
                                                     comment: CSRForm?.get('CSRRows')?.value[i].description
                                                     }"
                    [customSpanClass]="{'alternative2': !CSRForm.get('CSRRows')?.value[i]?.isEditable}"
                    (commentChange)="onOverlayChange($event.comment, 'description', i)">
                  </textareaoverlay>
                </td>
              </ng-container>

              <ng-container matColumnDef="description_ref">
                <th mat-header-cell *matHeaderCellDef style="width:12%">Description Ref</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:12%">
                  <div>{{ CSRForm?.get('CSRRows')?.value[i].description_Ref }}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef style="width:8%">Created</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:8%">
                  <div>{{ CSRForm.get('CSRRows')?.value[i].createdAtUtc | date:'dd/MM/yyyy HH:mm' }}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="modified">
                <th mat-header-cell *matHeaderCellDef style="width:8%">Modified</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:8%">
                  <div>{{ CSRForm.get('CSRRows')?.value[i].changedAtUtc | date:'dd/MM/yyyy HH:mm' }}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="isglobal">
                <th mat-header-cell *matHeaderCellDef style="width:5%">Is Global?</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:5%">
                  <mat-checkbox [checked]="CSRForm.get('CSRRows')?.value[i].isGlobal"
                    (change)="changeIsGlobal(i, $event.checked)"
                    [ngClass]="!CSRForm.get('CSRRows')?.value[i]?.isEditable ? 'black' :''"
                  [disabled]="CSRForm.get('CSRRows')?.value[i]?.isEditable"></mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="activehours">
                <th mat-header-cell *matHeaderCellDef style="width:10%">Active Hours</th>
                <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:10%">
                  @if (CSRForm.get('CSRRows')?.value[i]?.isEditable) {
                    <div [innerHTML]="CSRForm.get('CSRRows')?.value[i].activeHours"></div>
                  }
                  @if (!CSRForm.get('CSRRows')?.value[i]?.isEditable) {
                    <mat-form-field floatLabel="auto">
                      <input matInput type="number"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="CSRForm.get('CSRRows')?.value[i].activeHours"
                        pattern="[0-9]*"
                        inputmode="numeric"
                        matTooltip="Only numbers allowed" />
                      </mat-form-field>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="integrationready">
                  <th mat-header-cell *matHeaderCellDef style="width:8%">Integration Ready</th>
                  <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:8%">
                    <mat-checkbox [checked]="CSRForm.get('CSRRows')?.value[i].integrationReady"
                      (change)="changeIntegrationReady(i, $event.checked)"
                      [ngClass]="!CSRForm.get('CSRRows')?.value[i]?.isEditable ? 'black' :''"
                    [disabled]="CSRForm.get('CSRRows')?.value[i]?.isEditable"></mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="patterndetection">
                  <th mat-header-cell *matHeaderCellDef style="width:8%">Pattern Detection</th>
                  <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:8%">
                    <mat-checkbox [checked]="CSRForm.get('CSRRows')?.value[i].patternDetection"
                      (change)="changePatternDetection(i, $event.checked)"
                      [ngClass]="!CSRForm.get('CSRRows')?.value[i]?.isEditable ? 'black' :''"
                    [disabled]="CSRForm.get('CSRRows')?.value[i]?.isEditable"></mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="documentationurl">
                  <th mat-header-cell *matHeaderCellDef style="width:12%">Documentation Url</th>
                  <td mat-cell *matCellDef="let element; let i = dataIndex" style="width:12%">
                    @if (CSRForm.get('CSRRows')?.value[i]?.isEditable) {
                      <div [innerHTML]="CSRForm.get('CSRRows')?.value[i].documentationUrl"></div>
                    }
                    @if (!CSRForm.get('CSRRows')?.value[i]?.isEditable) {
                      <mat-form-field floatLabel="always">
                        <input matInput type="text"
                          [ngModelOptions]="{standalone: true}"
                          [ngModel]="CSRForm.get('CSRRows')?.value[i].documentationUrl"
                          (ngModelChange)="onOverlayChange($event, 'documentationUrl', i)" />
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element; let i = dataIndex">
                      <div class="action-buttons">
                        @if (!CSRForm.get('CSRRows')?.value[i]?.isNewRow) {
                          <button mat-icon-button
                            [matTooltip]="getAddTaskTooltip()"
                            [disabled]="!isEnglishLanguage()"
                            color="warn"
                            (click)="addNewTaskRow(CSRForm.get('CSRRows')?.value[i],i)">
                            <mat-icon class="actionButtons">add</mat-icon>
                          </button>
                        }

                        @if (!CSRForm.get('CSRRows')?.value[i]?.isEditable) {
                          <button mat-icon-button
                            matTooltip="Cancel Changes"
                            color="warn"
                            (click)="resetRow(i)">
                            <mat-icon class="actionButtons">rotate_left</mat-icon>
                          </button>
                        }

                        @if (CSRForm.get('CSRRows')?.value[i]?.isEditable) {
                          <button mat-icon-button
                            matTooltip="Edit"
                            color="primary"
                            (click)="editRow(i)">
                            <mat-icon class="actionButtons">edit</mat-icon>
                          </button>
                        }

                        @if (!CSRForm.get('CSRRows')?.value[i]?.isNewRow) {
                          <button mat-icon-button
                            matTooltip="Delete"
                            color="warn"
                            (click)="onDelete(CSRForm.get('CSRRows')?.value[i]?.patternDefinitionId, i)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.colspan]="columnsToDisplay.length">
                      <div [@detailExpand]="checkExpanded(i) ? 'expanded' : 'collapsed'">
                        <table mat-table [dataSource]="CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows"
                          class="table-add-butt-header-orange mat-subtable-custom" id="patterntask">

                          <ng-container matColumnDef="taskid">
                            <th mat-header-cell *matHeaderCellDef style="width:8%" class="taskid-cell"> Task ID </th>
                            <td mat-cell *matCellDef="let element2; let j = index" style="width:8%" class="taskid-cell">
                              <div>
                                @if (CSRForm.get('CSRRows')?.value[i].patternDefinitionId > 0 && CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].taskSubId > 0) {
                                  GTL_{{ CSRForm.get('CSRRows')?.value[i].patternDefinitionId }}_{{ CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].taskSubId }}
                                } @else {
                                  <span style="font-style: italic; color: #888;">New</span>
                                }
                              </div>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="taskDescription">
                            <th mat-header-cell *matHeaderCellDef style="width:10%"> Task Description</th>
                            <td mat-cell *matCellDef="let element2, let j = index" style="width:10%">
                                                    <textareaoverlay [inputControls]="{
                                                                     isOpenOverlay: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isOpenOverlay,
                                                                     textAreaId: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].textAreaId,
                                                                     isEditable: !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isEditable,
                                                                     maxCommentLength: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].maxCommentLength,
                                                                     comment: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].taskDescription
                                                                 }"
                                [customSpanClass]="{'alternative2': !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable}"
                                (commentChange)="onOverlayChange($event.comment, 'taskDescription', i, j)">
                              </textareaoverlay>
                            </td>

                          </ng-container>
                          <ng-container matColumnDef="taskDescription_ref">
                            <th mat-header-cell *matHeaderCellDef style="width:10%"> Task Description Ref</th>
                            <td mat-cell *matCellDef="let element2, let j = index" style="width:10%">
                              <div>{{ CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].taskDescription_Ref }}</div>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="symptomdescription">
                            <th mat-header-cell *matHeaderCellDef style="width:10%">Symptom Description</th>
                            <td mat-cell *matCellDef="let element2; let j = index" style="width:10%">
                                                    <textareaoverlay [inputControls]="{
                                                                     isOpenOverlay: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isOpenOverlay,
                                                                     textAreaId: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].textAreaId,
                                                                     isEditable: !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isEditable,
                                                                     maxCommentLength: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].maxCommentLength,
                                                                     comment: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].symptomDescription
                                                                 }"
                                [customSpanClass]="{'alternative2': !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable}"
                                (commentChange)="onOverlayChange($event.comment, 'symptomDescription', i, j)">
                              </textareaoverlay>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="symptomdescription_ref">
                            <th mat-header-cell *matHeaderCellDef style="width:10%">Symptom Description Ref</th>
                            <td mat-cell *matCellDef="let element2; let j = index" style="width:10%">
                              <div>{{ CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].symptomDescription_Ref }}</div>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="taskcreated">
                            <th mat-header-cell *matHeaderCellDef style="width:8%"> Created </th>
                            <td mat-cell *matCellDef="let element2; let j = index" style="width:8%">
                              <div>{{ CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].createdAtUtc | date:'dd/MM/yyyy HH:mm' }}</div>
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="taskmodified">
                            <th mat-header-cell *matHeaderCellDef style="width:8%"> Modified </th>
                            <td mat-cell *matCellDef="let element2; let j = index" style="width:8%">
                              <div>{{ CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].changedAtUtc | date:'dd/MM/yyyy HH:mm' }}</div>
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="taskhours">
                            <th mat-header-cell *matHeaderCellDef style="width:6%"> Hours </th>
                            <td mat-cell *matCellDef="let element; let j = index" style="width:6%">
                              @if (CSRForm.get('CSRRows')?.value[i]?.patternTasks.TaskRows[j].isEditable) {
                                <div [innerHTML]="CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.taskHours"></div>
                              }
                              @if (!CSRForm.get('CSRRows')?.value[i]?.patternTasks.TaskRows[j].isEditable) {
                                <mat-form-field style="width: 100%">
                                  <input matInput type="number"
                                    [ngModelOptions]="{standalone: true}"
                                    [ngModel]="CSRForm.get('CSRRows')?.value[i]?.patternTasks.TaskRows[j].taskHours"
                                    (ngModelChange)="CSRForm.get('CSRRows')?.value[i]?.patternTasks?.TaskRows?.[j] && (this.CSRForm.get('CSRRows')!.value[i].patternTasks.TaskRows[j].taskHours = $event)"
                                    pattern="[0-9]*"
                                    min="0"
                                    max="8"
                                    inputmode="numeric"
                                    matTooltip="Only numbers allowed" />
                                  </mat-form-field>
                                }
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="priority">
                              <th mat-header-cell *matHeaderCellDef style="width:6%"> Priority </th>
                              <td mat-cell *matCellDef="let element; let j = index" style="width:6%">
                                @if (CSRForm.get('CSRRows')?.value[i]?.patternTasks.TaskRows[j].isEditable) {
                                  <div [innerHTML]="CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.priority"></div>
                                }
                                @if (!CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable) {
                                  <mat-form-field floatLabel="always">
                                    <mat-select style="min-width: 200px; display:flex; justify-content:center; color:red"
                                      [ngModel]="CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].priority"
                                      (ngModelChange)="CSRForm.get('CSRRows')?.value[i]?.patternTasks?.TaskRows?.[j] && (CSRForm.get('CSRRows')!.value[i].patternTasks.TaskRows[j].priority = $event)"
                                      [ngModelOptions]="{standalone: true}">
                                      <mat-option [value]="-1" [disabled]="false">Select</mat-option>
                                      <mat-option [value]="1">1</mat-option>
                                      <mat-option [value]="2">2</mat-option>
                                      <mat-option [value]="3">3</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                }
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="context">
                              <th mat-header-cell *matHeaderCellDef style="width:10%"> Context </th>
                              <td mat-cell *matCellDef="let element2, let j = index" style="width:10%">
                                                    <textareaoverlay [inputControls]="{
                                                                     isOpenOverlay: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isOpenOverlay,
                                                                     textAreaId: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].textAreaId,
                                                                     isEditable: !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isEditable,
                                                                     maxCommentLength: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].maxCommentLength,
                                                                     comment: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].context
                                                                 }"
                                  [customSpanClass]="{'alternative2': !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable}"
                                  (commentChange)="onOverlayChange($event.comment, 'context', i, j)">
                                </textareaoverlay>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="urlsupport">
                              <th mat-header-cell *matHeaderCellDef style="width:8%"> URL Support </th>
                              <td mat-cell *matCellDef="let element2, let j = index" style="width:8%">
                                                    <textareaoverlay [inputControls]="{
                                                                     isOpenOverlay: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isOpenOverlay,
                                                                     textAreaId: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].textAreaId,
                                                                     isEditable: !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isEditable,
                                                                     maxCommentLength: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].maxCommentLength,
                                                                     comment: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].urlSupport
                                                                 }"
                                  [customSpanClass]="{'alternative2': !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable}"
                                  (commentChange)="onOverlayChange($event.comment, 'urlSupport', i, j)">
                                </textareaoverlay>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="tags">
                              <th mat-header-cell *matHeaderCellDef style="width:8%"> Tags </th>
                              <td mat-cell *matCellDef="let element2, let j = index" style="width:8%">
                                                    <textareaoverlay [inputControls]="{
                                                                     isOpenOverlay: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isOpenOverlay,
                                                                     textAreaId: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].textAreaId,
                                                                     isEditable: !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].isEditable,
                                                                     maxCommentLength: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].maxCommentLength,
                                                                     comment: CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j].tags
                                                                 }"
                                  [customSpanClass]="{'alternative2': !CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable}"
                                  (commentChange)="onOverlayChange($event.comment, 'tags', i, j)">
                                </textareaoverlay>
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="actions">
                              <th mat-header-cell *matHeaderCellDef></th>
                              <td mat-cell *matCellDef="let element2; let j = index">
                                <div class="action-buttons">
                                  @if (!CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable) {
                                    <button mat-icon-button
                                      matTooltip="Cancel Changes"
                                      color="warn"
                                      (click)="resetTaskRow(i,j)">
                                      <mat-icon class="actionButtons">rotate_left</mat-icon>
                                    </button>
                                  }

                                  @if (CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable) {
                                    <button mat-icon-button
                                      matTooltip="Edit"
                                      color="primary"
                                      (click)="editTaskRow(i,j)">
                                      <mat-icon class="actionButtons">edit</mat-icon>
                                    </button>
                                  }

                                  @if (!CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isNewRow) {
                                    <button mat-icon-button
                                      matTooltip="Delete"
                                      color="warn"
                                      (click)="onDeletePatternTask(CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.patternTaskId, i, j)">
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  }
                                </div>
                              </td>
                            </ng-container>

                            <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsToDisplay"></tr>
                            <tr mat-row *matRowDef="let element2; let j = index; columns: subcolumnsToDisplay;"
                              [class.alternative2]="!CSRForm.get('CSRRows')?.value[i].patternTasks.TaskRows[j]?.isEditable"
                            class="subitem"></tr>
                          </table>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="savefooter">
                      <th mat-footer-cell *matFooterCellDef [attr.colspan]="columnsToDisplay.length">
                        <div class="OrangeButton">
                          <button mat-raised-button type="submit" (click)="onSave()"
                            [disabled]="!anyChange()"
                            [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'"
                            class="button-color-fix pull-right">
                            Save
                            <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                          </button>
                        </div>
                      </th>

                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['headertitle', 'headeraddbutton'];"></tr>
                    <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay;"></tr>
                    <tr mat-row *matRowDef="let row; let i = dataIndex; columns: columnsToDisplay;"
                    [class.alternative2]="!CSRForm.get('CSRRows')?.value[i]?.isEditable"></tr>

                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="row-subitem"></tr>

                    <tr mat-footer-row *matFooterRowDef="['savefooter'];" style="width:100%"></tr>
                  </table>
                </ng-container>
              </form>
            </div>
          </div>
        </div>
      </div>

